import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/depositos';
import Depositos from './DepositosList';


const ms2p = (state) => {
  return {
    ...state.deposito,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Depositos);
